<template>
  <el-footer>
     <div>©版权所有北京一脉阳光医学信息技术有限公司ICP证：粤ICP备15039523号-1 <span class="marl10 marr10">|</span> <span class="footerpolicy cur" @click="toterms">隐私政策</span></div>
     <div>京公网安备11010502031880号</div>
   </el-footer>
</template>

<script>
export default {
  name: 'footers',
		methods:{
      // 隐私政策
			toterms(){
				window.location.href = 'https://terms.rimagdata.com/';
      },
    
    },
		activated(){
		}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
 .el-footer {
    position: fixed;
    bottom: 0;
    width: 100%;
    height: 65px!important;
    line-height: 22px!important;
    background-color: #ffffff;
    font-size: 12px;
    color: #06255E;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: justify;
    -ms-flex-pack: justify;
    justify-content: space-between;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    text-align: center;
  }
  .marl10 {
    margin-left: 10px;
  }
  .marr10 {
    margin-right: 10px;
  }
  .cur {
    cursor: pointer;
  }
  .footerpolicy:hover {
    color: #3291f1;
  }
</style>
